import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import { DatePicker, Dropdown, Stack } from '@fluentui/react';
import moment from 'moment';
import { IOutcomeResourceShorterProps } from '../../../../../props/finance/outcomes';
import GeneralService from '../../../../../services/general';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// assets

// services

// props

// components

type IncomesSummaryFilterProps = {
    startDate: string;
    endDate: string;
    onChange(startDate: string, endDate: string): void;
}

const IncomesSummaryFilterDate: React.FC<IncomesSummaryFilterProps> = (props: IncomesSummaryFilterProps) => {
    const { banner, user } = useStore();

    const [dateRange, setDateRange] = React.useState<string>("thisweek");
    const [selectedDate, setSelectedDate] = React.useState<{ startDate: string, endDate: string }>({
        startDate: props.startDate,
        endDate: props.endDate
    });

    useEffect(() => {
        setSelectedDate({
            startDate: props.startDate,
            endDate: props.endDate
        });
    }, [props.startDate, props.endDate]);

    return <Stack>
        <Stack horizontal tokens={{ childrenGap: 15 }}>
            <Dropdown label={'Date range'}
                options={[
                    { key: 'thisweek', text: 'This week' },
                    { key: 'lastweek', text: 'Last week' },
                    { key: 'thismonth', text: 'This month' },
                    { key: 'lastmonth', text: 'Last month' },
                    { key: 'last3month', text: 'Last 3 months' },
                    { key: 'thisyear', text: 'This year' },
                    { key: 'lastyear', text: 'Last year' },
                    { key: 'custom', text: 'Custom' }
                ]}
                styles={{ root: { width: 200 } }}
                selectedKey={dateRange}
                onChange={(ev, opt) => {
                    let _startDate = selectedDate.startDate;
                    let _endDate = selectedDate.endDate;
                    let _dateRange = opt?.key as string || dateRange;

                    if (_dateRange === 'thismonth') {
                        _startDate = moment().startOf('month').toISOString();
                        _endDate = moment().endOf('month').toISOString();
                    } else if (_dateRange === 'lastmonth') {
                        _startDate = moment().startOf('month').add(-1, 'month').toISOString();
                        _endDate = moment().endOf('month').add(-1, 'month').toISOString();
                    } else if (_dateRange === 'last3month') {
                        _startDate = moment().startOf('month').add(-2, 'month').toISOString();
                        _endDate = moment().endOf('month').toISOString();
                    } else if (_dateRange === 'thisweek') {
                        _startDate = moment().startOf('week').toISOString();
                        _endDate = moment().endOf('week').toISOString();
                    } else if (_dateRange === 'lastweek') {
                        _startDate = moment().startOf('week').add(-1, 'week').toISOString();
                        _endDate = moment().endOf('week').add(-1, 'week').toISOString();
                    } else if (_dateRange === 'thisyear') {
                        _startDate = moment().startOf('year').toISOString();
                        _endDate = moment().endOf('year').toISOString();
                    } else if (_dateRange === 'lastyear') {
                        _startDate = moment().startOf('year').add(-1, 'year').toISOString();
                        _endDate = moment().endOf('year').add(-1, 'year').toISOString();
                    }

                    setDateRange(_dateRange);
                    props.onChange(_startDate, _endDate);
                }} />
            {dateRange === 'custom' ? <Stack verticalAlign='center' horizontal tokens={{ childrenGap: 20 }} styles={{ root: { paddingTop: 26 } }}>
                <DatePicker value={moment(selectedDate.startDate).toDate()}
                    styles={{ root: { width: 150 } }}
                    formatDate={GeneralService.formatDate}
                    onSelectDate={(date) => {
                        const _startDate = date ? moment(date).startOf('day').toISOString() : selectedDate.startDate;
                        props.onChange(_startDate, selectedDate.endDate);
                    }} />
                <Stack><FontAwesomeIcon icon={faArrowRight} /></Stack>
                <DatePicker value={moment(selectedDate.endDate).toDate()}
                    styles={{ root: { width: 150 } }}
                    formatDate={GeneralService.formatDate}
                    onSelectDate={(date) => {
                        const _endDate = date ? moment(date).endOf('day').toISOString() : selectedDate.endDate;
                        props.onChange(selectedDate.startDate, _endDate);
                    }} />
            </Stack> : null}
        </Stack>
    </Stack>;
};

export default IncomesSummaryFilterDate;
